import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Mail, MapPin, Phone } from "lucide-react";
import { COMPANY, NAV } from "@/data/company";
import { MosaicStrip } from "@/components/motion/Tiles";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink text-white" data-testid="footer">
    <MosaicStrip height={6} size={14} />
    <div className="absolute inset-0 blueprint opacity-60" />
    <div className="container-x relative pt-20 pb-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img src="/images/logo-desp-white.png" alt="Desp sas - Noleggi Piattaforme Aeree e Escavatori" className="h-36 w-auto sm:h-44" data-testid="footer-logo" />
          <p className="mt-6 max-w-sm text-base leading-relaxed text-white/60">
            Noleggio piattaforme aeree, escavatori e macchine per il cantiere a Catania. Consegniamo in tutta la Sicilia orientale.
          </p>
          <p className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight text-blue-500">{COMPANY.tagline}</p>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-white/50">Navigazione</p>
          <ul className="mt-5 space-y-3">
            {NAV.flatMap((n) => (n.children ? [n, ...n.children] : [n])).map((n) => (
              <li key={n.to + n.label}>
                <Link to={n.to} className="group inline-flex items-center gap-1 font-display text-lg font-semibold uppercase tracking-wide text-white/80 transition-colors hover:text-white" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {n.label}
                  <ArrowUpRight className="h-4 w-4 opacity-0 -translate-y-1 translate-x-[-4px] transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="eyebrow text-white/50">Contatti</p>
          <ul className="mt-5 space-y-4 text-base">
            <li>
              <a href={`tel:${COMPANY.phoneIntl}`} className="flex items-start gap-3 text-white/80 transition-colors hover:text-white" data-testid="footer-phone-link">
                <Phone className="mt-0.5 h-5 w-5 text-blue-500" /> {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="flex items-start gap-3 text-white/80 transition-colors hover:text-white" data-testid="footer-email-link">
                <Mail className="mt-0.5 h-5 w-5 text-blue-500" /> {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/80">
              <MapPin className="mt-0.5 h-5 w-5 text-blue-500" /> {COMPANY.area}
            </li>
            <li className="flex items-start gap-3 text-white/80">
              <Clock className="mt-0.5 h-5 w-5 text-blue-500" />
              <div className="space-y-1" data-testid="footer-hours">
                {COMPANY.hours.map((h) => (
                  <div key={h.days} className="flex gap-3">
                    <span className="w-32 text-white/50">{h.days}</span>
                    <span>{h.time}</span>
                  </div>
                ))}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} {COMPANY.name} — Catania. Tutti i diritti riservati.</p>
        <p className="font-mono uppercase tracking-widest">Noleggio piattaforme aeree · escavatori · Catania</p>
      </div>
    </div>
  </footer>
);
